import { Switch } from 'react-router-dom';
import Balcao from '../pages/Balcao';
import ForgotPassword from '../pages/ForgotPassword';
import GeolocationDenied from '../pages/GeolocationDenied';
import Login from '../pages/Login';
import ResetPassoword from '../pages/ResetPassword';
import Route from './Route';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={Login} />
      <Route path="/forgotPassword" exact component={ForgotPassword} />
      <Route path="/resetPassword" exact component={ResetPassoword} />
      <Route path="/geolocationDenied" exact component={GeolocationDenied} />
      <Route path="/balcao" exact component={Balcao} isPrivate />
    </Switch>
  );
};

export default Routes;
